const SimpleButton = ({
  title = '',
  iconPath = null,
  hint = '',
  onClick,
  classes = 'bg-primary',
  alt = "",
  disabled = false
}) => {
  return (
    <button
      type="button"
      title={hint}
      disabled={disabled}
      className={`nice-style-btn nice-flex-row ${classes} ${
        disabled ? "opacity-50 cursor-not-allowed" : ""
      }`}
      onClick={(e) => {
        if (disabled) return;
        if (onClick) onClick(e);
      }}
    >
      {title}
      {iconPath && <img src={iconPath} alt={title ? title : alt} />}
    </button>
  );
};

export default SimpleButton;